const isExternalURL = (url: string = '') =>
  /^((https?:)?\/\/|mailto|tel)/.test(url)

export default isExternalURL
